var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.users),function(user){return _c('subscription-item',{key:user.username,attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }